import ShowReel from '../modules/showreel.js';
import * as utils from '../utils.js';
export function initHome() {

	var Home = Barba.BaseView.extend({

		namespace: 'page-home',

		onEnter: function() {

			//console.log('Init Home');

			const $body = document.querySelector('body');
			const $html = document.querySelector('html');

			//SHOWREEL
			const showreelHome = new ShowReel(document.querySelector('.hero .video--preview'));
			
		
			//SCROLLTO
			this.container.querySelector('.scrollTo').addEventListener('click', (e) => {
				e.preventDefault();
				if (window.innerWidth >= 768) {
					onScrollNext();
				} else {
					TweenMax.to(window, slideDuration, {scrollTo: {y:projectsContainer.offsetTop, autoKill:false}, ease:Power3.easeInOut}, 0);
				}
			});
			
			
			//PROJECTS
			const brand = document.querySelector('header .brand');
			const hero = this.container.querySelector('.hero');
			const projectsContainer = this.container.querySelector('.projects');
			const projectPreviews = this.container.querySelectorAll('.project--preview');
			const lastIndex = this.container.querySelectorAll('.project').length;
			const slideDuration = 1.2;
			const animationDuration = 1;
			const animationDelay = 0.2;
			this.pageSy = window.pageYOffset || document.documentElement.scrollTop;
			let introStep = "showreel";
			let sliding = false;
			let activeSlideIndex = 0;


			var onScrollPrev = () => {
				
				if (sliding) return;
				
				// ScrollTo Showreel
				if (!sliding && activeSlideIndex === 0 && introStep === "previews") {
					activeSlideIndex = 0;
					introStep = "showreel";
					sliding = true;
					hero.inTL.delay(0).restart();
					projectPreviews[0].animateOut();
					document.querySelector('body > header').classList.remove('white');
					TweenMax.to(hero, slideDuration, {y:"0%", ease:Power3.easeInOut}, 0);
					TweenMax.to(projectsContainer, slideDuration, {y:"100%", ease:Power3.easeInOut}, 0);
				}
				
				// Prev Project
				if (!sliding && activeSlideIndex >= 1 && introStep === "previews" && this.pageSy === 0) {
					sliding = true;
					activeSlideIndex--;
					projectPreviews[activeSlideIndex + 1].animateOut();
					projectPreviews[activeSlideIndex].animateIn(true);
				}

				//From more
				if (introStep === "more" && this.pageSy === 0 && !$html.classList.contains('overflow')) {
					$html.classList.add('overflow');
					introStep = "previews";
					this.hammer.get('pan').set({ enable: true });
				}
				
			}
			
			var onScrollNext = () => {
				
				if (sliding) return;
				
				// ScrollTo Projects
				if (!sliding && activeSlideIndex === 0 && introStep === "showreel" ) {
					sliding = true;
					introStep = "previews";
					hero.outTL.delay(0).restart();
					projectPreviews[0].animateIn(true);
					document.querySelector('body > header').classList.add('white');
					TweenMax.to(hero, slideDuration, {y:"-100%", ease:Power3.easeInOut}, 0);
					TweenMax.to(projectsContainer, slideDuration, {y:"0%", ease:Power3.easeInOut}, 0);
				}
				
				
				// Next Project
				if (!sliding && activeSlideIndex < (lastIndex - 1) && introStep === "previews" && this.pageSy === 0) {
					sliding = true;
					activeSlideIndex++;
					projectPreviews[activeSlideIndex - 1].animateOut();
					projectPreviews[activeSlideIndex].animateIn(true);
				}
				
				// More Content
				if (!sliding && introStep === "previews" && activeSlideIndex === (lastIndex - 1) && $html.classList.contains('overflow')) {
					introStep = "more";
					sliding = false;
					this.hammer.get('pan').set({ enable: false });
					$html.classList.remove('overflow');
				}
			}
			
			this.pageWheel = (ev) => {
				if (sliding) return;
				if (ev.deltaY < 0) onScrollPrev();
				else if (ev.deltaY > 1) onScrollNext();
			}
			
			this.pageSwipeUp = (ev) => {
				if (sliding) return;
				onScrollPrev();
			}
			
			this.pageSwipeDown = (ev) => {
				if (sliding) return;
				onScrollNext();
			}
			
			this.pageScroll = (ev) => {
				this.pageSy = window.pageYOffset || document.documentElement.scrollTop;
				if (window.innerWidth >= 768 && this.pageSy === 0 && introStep === "more" ) {
					this.hammer.get('pan').set({ enable: true });
				}
			}
			
			//setup
			if (window.innerWidth >= 768) {
				
				//SCROLL
				$html.classList.add('overflow');
				window.addEventListener("wheel", this.pageWheel);
				//Swipe
				this.hammer = new Hammer(this.container);
				this.hammer.get('pan').set({ direction: Hammer.DIRECTION_ALL });
				this.hammer.on('pandown', this.pageSwipeUp );
				this.hammer.on('panup', this.pageSwipeDown);
				
				//timelineIn
				TweenMax.set(hero.querySelector('.video--preview'), {right:"100%", width:"100%"});
				TweenMax.set(hero.querySelector('.inner > *'),{x:200, opacity:0});
				hero.inTL = new TimelineMax({delay:animationDuration * 0.5, paused:true,
					onStart:()=>{
						hero.classList.add('no-transition');
						document.querySelector('body > header').classList.remove('white');
					}, onComplete:() => {
						hero.classList.remove('no-transition');
						hero.querySelector('.video--cover').play();
						sliding = false;
					}
				});
				hero.inTL.fromTo(hero.querySelector('.video--preview'), animationDuration, {right:"100%", width:"100%"}, {right:"11%", width:"30%", overwrite: "all", ease:Power3.easeOut}, 0);
				hero.inTL.staggerFromTo(hero.querySelectorAll('.inner > *'), animationDuration, {x:200, opacity:0}, {x:0, opacity:1, ease:Power3.easeOut}, 0.05, animationDelay * 2);
				hero.inTL.play();
				
				//timelineOut
				hero.outTL = new TimelineMax({paused:true,
					onStart:()=> {
						hero.classList.add('no-transition');
						hero.querySelector('.video--cover').pause();
					}, onComplete:() => {
						hero.classList.remove('no-transition');
						document.querySelector('body > header').classList.add('white');
					}
				}).timeScale(1.5);
				hero.outTL.to(hero.querySelector('.video--preview'), animationDuration, {right:"-100%", width:"100%", ease:Power3.easeIn}, 0);
				hero.outTL.staggerTo(hero.querySelectorAll('.inner > *'), animationDuration, {x:200, opacity:0, ease:Power3.easeIn}, 0.05, 0);
				
				
			} else {
				
				inView('.project--preview')
		    .on('enter', el => {
					if (!el.done) {
						el.animateIn(true);
						el.done = true;
					}
					el.querySelector('.video--cover').play();
		    }).on('exit', el => {
					el.querySelector('.video--cover').pause();
		    });
				
			}
			
			//ANIMATIONs
			if (projectPreviews) {
				projectPreviews.forEach((el) => {
					
					//Setup
					TweenMax.set(el.querySelector('.video--preview'), {right:"100%", width:"100%"});
					TweenMax.set(el.querySelector('.video--color'), {right:"100%", width:"100%"});
					TweenMax.set(el.querySelectorAll('.inner > *'), {x:200, opacity:0});
					if (el.querySelector('.project--infos')) {
						TweenMax.set(el.querySelectorAll('.project--infos span > span'), {y:"100%"});
					}
					
					el.querySelector('.video--cover').pause();
					
					//animateIn
					el.animateIn = (delay) => {
						
						let delayTL = 0;
						if (delay) delayTL = animationDuration * 0.5;
						
						const randomPos = utils.randomInt(20, 30) + "%";
						const randomWidth = utils.randomInt(20, 30) + "%";
						
						const inTL = new TimelineMax({delay:delayTL, paused:true,
							onStart:()=>{
								
								el.classList.add('no-transition');
								el.querySelector('.video--cover').play();
								
							}, onComplete:() => {
								
								el.classList.add('is-active');
								el.classList.remove('no-transition');
								sliding = false;
								
							}
						});
						
						inTL.fromTo(el.querySelector('.video--preview'), animationDuration, {right:"100%", width:"100%"}, {right:randomPos, width:randomWidth, ease:Power3.easeOut}, 0);
						inTL.fromTo(el.querySelector('.video--color'), animationDuration + 0.1, {right:"100%", width:"100%"}, {right:randomPos, width:randomWidth, ease:Power3.easeOut}, 0);
						inTL.staggerFromTo(el.querySelectorAll('.inner > *'), animationDuration, {x:200, opacity:0}, {x:0, opacity:1, ease:Power3.easeOut}, 0.05, animationDelay * 2);
						if (el.querySelector('.project--infos')) {
							inTL.staggerFromTo(el.querySelectorAll('.project--infos span > span'), animationDuration, {y:"100%"}, {y:"0%", ease:Power3.easeOut}, 0.05, animationDelay * 2 + 0.3);
						}
						
						inTL.play();
						
					}	
					el.animateOut = () => {
						
						const outTL = new TimelineMax({paused:true,
							onStart:()=>{
								
								el.classList.remove('is-active');
								el.classList.add('no-transition');
								el.querySelector('.video--cover').pause();
								
							}, onComplete:() => {
								
								el.classList.remove('no-transition');
								
							}
						}).timeScale(1.5);
					
						outTL.to(el.querySelector('.video--preview'), animationDuration, {right:"-100%", width:"100%", ease:Power3.easeIn}, 0);
						outTL.to(el.querySelector('.video--color'), animationDuration - 0.1, {right:"-100%", width:"100%", ease:Power3.easeIn}, 0);
						outTL.staggerTo(el.querySelectorAll('.inner > *'), animationDuration, {x:200, opacity:0, ease:Power3.easeIn}, 0.05, 0);
						if (el.querySelector('.project--infos')) {
							outTL.staggerTo(el.querySelectorAll('.project--infos span > span'), animationDuration, {y:"100%", ease:Power3.easeIn}, 0.05, 0);
						}
						
						outTL.play();
						
					}
					
					el.addEventListener('click', (e) => {
						el.querySelector('.video--cover').play();
					});
					
				});
			}
			
			window.addEventListener('scroll', this.pageScroll);

		},

		onLeave: function() {
			
			const $html = document.querySelector('html');
			
			if (window.innerWidth >= 768) {
				$html.classList.remove('overflow');
				this.hammer.off('pandown', this.pageSwipeUp );
				this.hammer.off('panup', this.pageSwiperDown);
				window.removeEventListener("wheel", this.pageWheel);
				window.removeEventListener('scroll', this.pageScroll);
			}

		}

	})

	Home.init();

}
